module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/lib/internal/streams/stream-browser.js